export const STALE_TIME_MS = 1_800_000;
